import { ApiClient, apiClient } from "../../../core/api_client";
import { generateCrudRepoFactory } from "../../../core/crud";
import { ICRUDRepo } from "../../../core/models";
import { budgetFromJson, budgetToJson, IBudget, IBudgetForm } from "./entities";

interface IBudgetRepo extends ICRUDRepo<IBudget, IBudgetForm> {}

const URL = "v1/budget";

const BudgetRepoImplFactory = (apiClient: ApiClient): IBudgetRepo => {
  const r: IBudgetRepo = {
    ...generateCrudRepoFactory<IBudget, IBudgetForm>(apiClient, URL, budgetFromJson, budgetToJson),
  };

  return r;
};

export const BudgetRepoImpl = BudgetRepoImplFactory(apiClient);
